import { OptionsWithoutBackground } from "src/routes/onboarding/shared/components/optionsWithoutBackground";
import background from "./bg.png";
import img1 from "./img1.png";
import img2 from "./img2.png";
import { useNavigate } from "react-router";

const data = [
  {
    emoji: img1,
    displayValue: "Yes",
    value: "Yes",
  },
  {
    emoji: img2,
    value: "No",
    displayValue: "No",
  },
];

export const Smartwatch = ({ onNextStep, onTrackEvent }) => {
  const navigate = useNavigate()
  const handleNextStep = (v) => {
    onTrackEvent?.(v.displayValue);
    localStorage.setItem("smartwatch", v.value); // ?

    if (v.value === "Yes") {
      onNextStep?.();
    } else {
      navigate('/onboarding/24');
    }
  };
  return (
    <OptionsWithoutBackground
      isWalky={true}
      data={data}
      title="Do you wear a smartwatch or fitness tracker?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
